import apiCall from "./apiCall";
// eslint-disable-next-line import/no-anonymous-default-export
export default {
  async createSupplierPayment(data) {
    let response = await apiCall(
      "supplier_invoices_payment/create_supplier_payment",
      data
    );
    return response;
  },
  async fetchSupplierInvoicesPayments(data) {
    let response = await apiCall(
      "supplier_invoices_payment/list_supplier_payments",
      data
    );
    return response;
  },

  async fetchSupplierInvoicesSelectable(data) {
    let response = await apiCall(
      "supplier_invoices/list_supplier_invoices_selectables",
      data
    );
    return response;
  },

  async fetchSupplierInvoicePaymentsDetails(data) {
    let response = await apiCall(
      "supplier_invoices_payment/get_supplier_invoice_details",
      data
    );
    return response;
  },
};
